import React from 'react'
import { Navigate } from 'react-router-dom'

import { lazyImport } from '@procom-labs/common'

import { CommonRoutesPaths } from '@resume-portal/routes/routes.enum'

import { Layout } from './layout'

const { ResumeBuilder } = lazyImport(
  () => import('@resume-portal/features/resume-builder/components'),
  'ResumeBuilder'
)

const { JoinOrganization } = lazyImport(
  () => import('@resume-portal/features/join-organization'),
  'JoinOrganization'
)

const { OrganizationSettingsLayout } = lazyImport(
  () => import('@resume-portal/features/organization'),
  'OrganizationSettingsLayout'
)

const { UsersAndTeams } = lazyImport(
  () => import('@resume-portal/features/users-and-teams'),
  'UsersAndTeams'
)

const { TemplateSettings } = lazyImport(
  () => import('@resume-portal/features/template-settings'),
  'TemplateSettings'
)

const { AdminDashboard } = lazyImport(
  () => import('@resume-portal/features/admin-dashboard'),
  'AdminDashboard'
)

const { PricingAndPlans } = lazyImport(
  () => import('@resume-portal/features/pricing-and-plans'),
  'PricingAndPlans'
)

const { CheckoutComplete } = lazyImport(
  () => import('@resume-portal/features/pricing-and-plans'),
  'CheckoutComplete'
)

export const privateRoutes = [
  {
    path: CommonRoutesPaths.GorillaWorksResumeBuilder,
    element: <Navigate to="/" />,
  },
  {
    path: CommonRoutesPaths.ProcomResumeBuilder,
    element: <Navigate to="/" />,
  },
  {
    path: CommonRoutesPaths.AplinResumeBuilder,
    element: <Navigate to="/" />,
  },
  {
    path: CommonRoutesPaths.EastWestStaffingResumeBuilder,
    element: <Navigate to="/" />,
  },
  {
    path: CommonRoutesPaths.IMethodsResumeBuilder,
    element: <Navigate to="/" />,
  },
  {
    path: CommonRoutesPaths.MedmasaResumeBuilder,
    element: <Navigate to="/" />,
  },
  {
    path: CommonRoutesPaths.BeaconHillStaffingResumeBuilder,
    element: <Navigate to="/" />,
  },
  {
    path: CommonRoutesPaths.WestCorpResumeBuilder,
    element: <Navigate to="/" />,
  },
  {
    path: CommonRoutesPaths.CustomStaffingResumeBuilder,
    element: <Navigate to="/" />,
  },
  {
    path: CommonRoutesPaths.NewburyResumeBuilder,
    element: <Navigate to="/" />,
  },
  {
    path: CommonRoutesPaths.HRProjectPartnersResumeBuilder,
    element: <Navigate to="/" />,
  },
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Navigate to={CommonRoutesPaths.Parse} />,
      },
      {
        path: CommonRoutesPaths.Parse,
        element: <ResumeBuilder />,
      },
      {
        path: CommonRoutesPaths.Organization,
        element: <OrganizationSettingsLayout />,
      },
      {
        path: CommonRoutesPaths.JoinOrganization,
        element: <JoinOrganization />,
      },
      {
        path: CommonRoutesPaths.UsersAndTeams,
        element: <UsersAndTeams />,
      },
      {
        path: CommonRoutesPaths.Templates,
        element: <TemplateSettings />,
      },
      {
        path: CommonRoutesPaths.Admin,
        element: <AdminDashboard />,
      },
      {
        path: CommonRoutesPaths.PricingAndPlans,
        element: <PricingAndPlans />,
      },
      {
        path: CommonRoutesPaths.CheckoutComplete,
        element: <CheckoutComplete />,
      },
    ],
  },
]
